import { FUTURE_GROWTH } from '../mock';

export default function FutureGrowth() {
  return (
    <section className="bg-[#e9e3d6] py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          <div>
            <span className="eyebrow">Future Growth</span>
            <h2 className="font-serif-display text-[42px] md:text-[54px] leading-[1.05] mt-6">
              Phase One is<br />
              <em className="text-[#b39352] italic">only the beginning.</em>
            </h2>
            <p className="mt-6 text-[14px] leading-[1.85] text-[#0d281e]/80 max-w-lg">
              Valley Mills is designed to grow alongside its occupiers. Future phases will bring
              additional industrial, commercial and estate improvements.
            </p>
          </div>

          <div className="grid grid-cols-1 gap-0">
            {FUTURE_GROWTH.map((f, i) => (
              <div key={f} className="num-list-item">
                <span className="num">{String(i + 1).padStart(2, '0')}</span>
                <span className="text-[15px] text-[#0d281e]">{f}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
